import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface ClickOutSideEventI extends MouseEvent {
  path: any[];
}

/**
 * Validate if the id is present inside of an event path
 */
export const isElementIdInEventPath = (evt: ClickOutSideEventI, elementId: string) => {
  const evtPath = evt?.composedPath() || evt.path;
  return !evtPath.find(htmlEle => htmlEle.id === elementId);
};

/**
 * Directive that add a hostListener to validate according the element id
 * if the user clicks in a element outside from the element with this id
 * and allows to call a function if the click was from outside
 */
@Directive({
  selector: '[clickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  @Input() elementId: string = '';
  @Output() onClickOutside = new EventEmitter<ClickOutSideEventI>();

  @HostListener('document:click', ['$event'])
  clickOutside(evt: ClickOutSideEventI) {
    if (isElementIdInEventPath(evt, this.elementId)) {
      this.onClickOutside.emit(evt);
    }
  }
}
